import { parseTime } from '@/common/utils/Date.js'
import loadMore from '@/common/components/load-more/index.vue'
export default(serviceUrl, createdFetech = true, params = {}) => ({
  components: { loadMore },
  data() {
    return {
      finish: Function,
      pages: {
        pageNo: 1,
        pageSize: 15
      },
      total: null,
      lists: []
    }
  },
  filters: {
    timeFilter(time) {
      return parseTime(time, '{y}-{m}-{d}')
    }
  },
  created() {
    if (createdFetech) this._getLists()
  },
  methods: {
    _refresh({ finish }) { // 刷新
      this.finish = finish
      this.pages.pageNo = 1
      this._getLists()
    },

    _loadmore({ finish }) { // 加载更多
      this.finish = finish
      if (this.lists.length === this.total) {
        this.$vux.toast.show({ text: this.$t('others').noData1, type: 'cancel' });
        this.finish()
        return
      }
      this.pages.pageNo += 1
      this._getLists()
    },

    _getLists() {
      this.$api.post(serviceUrl, this.pages, (resp) => {
        if (resp.data.code === 200) {
          let { total, list } = resp.data.data
          this.total = total
          list = this.resetList(list)
          this.lists = this.pages.pageNo === 1 ? [...list] : [...this.lists, ...list]
          this.implementationFetched(resp.data.data)
        } else {
          this.$vux.toast.show({ text: resp.data.msg, type: 'cancel' })
        }
        this.finish()
      }, (err) => {
        this.finish()
        this.$vux.toast.show({ text: err, type: 'cancel' })
      })
    },

    resetList(list) {
      return list
    },

    implementationFetched(v) {

    }
  }
})



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/mixins/load-list.js